import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AbstractSettingsComponent } from '@app/pages';
import { AuthService } from '@app/services';

@Component({
    standalone: false,
    selector: 'app-understand-maps',
    templateUrl: './understand-maps.component.html',
    styleUrls: ['./understand-maps.component.scss'],
})
export class UnderstandMapsComponent extends AbstractSettingsComponent {
    constructor(auth: AuthService, router: Router, route: ActivatedRoute) {
        super(auth, router, route);
    }
}
